import api from "./baseApi";
import endpoints from "./endpoints";

export const getReservations = async ({
  page = 1,
  perPage = 10,
  view,
  startDate,
  endDate,
  date,
  sortField,
  sortOrder,
  name,
  bookingRef,
  lotId,
  status,
  type,
  purpose,
} = {}) => {
  try {
    const params = {};

    // Scheduler mode does not require pagination
    if (view !== "scheduler") {
      params.page = page;
      params.perPage = perPage;
    }

    // View mode
    if (view) {
      params.view = view;
    }

    // Date filters
    if (date) {
      params.date = date;
    } else {
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
    }

    // Sorting
    if (sortField) params.sortField = sortField;
    if (sortOrder) params.sortOrder = sortOrder;

    // Filters
    if (name) params.name = name;
    if (bookingRef) params.bookingRef = bookingRef;
    if (lotId) params.lotId = lotId;
    if (status) params.status = status;
    if (type) params.type = type;
    if (purpose) params.purpose = purpose;

    const res = await api.get(endpoints.reservation.base, {
      params,
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message ||
      "failed to fetch reservations";

    throw new Error(message);
  }
};

export const getReservation = async (id) => {
  try {
    const res = await api.get(endpoints.reservation.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch reservation";

    throw new Error(message);
  }
};

export const createReservation = async (payload) => {
  try {
    const res = await api.post(endpoints.reservation.base, payload);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to create reservation";

    throw new Error(message);
  }
};

export const updateReservation = async (id, payload) => {
  try {
    const res = await api.put(endpoints.reservation.detail(id), payload);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to update reservation";

    throw new Error(message);
  }
};

export const deleteReservation = async (id) => {
  try {
    const res = await api.delete(endpoints.reservation.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete reservation";

    throw new Error(message);
  }
};

export const resendReservationConfirmation = async (
  id
) => {
  try {
    const { data } = await api.post(
      endpoints.reservation.resendConfirmation(id)
    );

    return data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message ??
        "failed to resend reservation confirmation"
    );
  }
};

export const getReservationMasterData = async () => {
  try {
    const res = await api.get(
      endpoints.reservation.masterData
    );

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message ||
      "failed to load reservation master data";

    throw new Error(message);
  }
};

export const cancelReservation = async (id) => {
  const { data } = await api.post(endpoints.reservation.cancel(id));
  return data;
};